import React, { useState, useContext } from 'react';
import { Container, Form, Row, Card, Col } from 'react-bootstrap';
import { ChevronDown, ChevronUp, HelpCircle } from 'react-feather';
import { Tooltip } from 'react-tippy';
import parse from 'html-react-parser';
import styled, { css } from 'styled-components';
import Mariana from '../../assets/img/mariana.png';
import ButtonInput from './ButtonInput';
import Avatar from '../Global/Avatar';

import { OptionContext } from '../../contexts/OptionContext';

const nextDefault = () => { };

const CardCustom = styled(Card)`
  ${(props) => css`
    background: ${props.background};
    color: ${props.foreground};
  `}
`;

const RadioInput = ({ type = 'checkbox', options = [], column = 'half', max = 20, next = nextDefault }) => {
  const [value, setValue] = useState(type === 'radio' || type === 'buttonSelector' ? '' : new Set());
  const [collapsed, setCollapsed] = useState(false);

  const optionContext = useContext(OptionContext);
  const { input } = optionContext;

  const isChecked = (option) => {
    if (type === 'radio' || type === 'buttonSelector') {
      return option.value === value;
    }
    return value.has(option.value);
  };

  const handleListMore = () => {
    setCollapsed(!collapsed);
  };

  const handleChange = (newValue) => {
    const values = [...newValue];
    if (type === 'checkbox') {
      if (values.findIndex((v) => v === 'none') > 0) {
        const updateValue = new Set();
        updateValue.add('none');
        setValue(updateValue);
      } else if (values.findIndex((v) => v === 'none') === 0 && values.length > 1) {
        newValue.delete('none');
        setValue(newValue);
      } else {
        setValue(newValue);
      }
    } else {
      setValue(newValue);
    }
  };

  return (
    <Container>
      {(type === 'radio' || type === 'checkbox')
        && (
          <Row className="mt-5 mb-0 ">
            {
              options.map((option, i) => (
                <Col key={`bot-check-${option + i}`} md={`${column === 'half' ? 6 : 12}`} xs={12} className="mt-0">
                  <CardCustom background={input.background.colorA} foreground={input.foreground} className="card-outline tooltip-activator py-3 px-4 mb-2">
                    <Form.Check inline id={`bot-check-${i}-id`}>
                      <Form.Check.Input type={type} checked={isChecked(option)} value={option.value} onChange={(e) => {
                        if (type === 'radio') {
                          handleChange(e.target.value);
                        } else {
                          if (!value.has(e.target.value)) {
                            value.add(e.target.value);
                          } else {
                            value.delete(e.target.value);
                          }
                          handleChange(new Set(value));
                        }
                      }}
                      />
                      <Form.Check.Label>{parse(option.text || option.label)}</Form.Check.Label>

                      {option.tooltip

                        && (
                          <div className="hidden-tooltip">
                            <Tooltip
                              position="top"
                              html={(
                                <Row style={{ minWidth: 150 }} className="py-3">
                                  <Col xs="3" className="text-center">
                                    <Avatar
                                      src={Mariana}
                                      rounded
                                      size="sm"
                                    />
                                  </Col>
                                  <Col xs={{ span: 9 }} className="text-left">
                                    {parse(option.tooltip)}
                                  </Col>
                                </Row>
                              )}
                            >
                              <HelpCircle className="help-circle ml-3" size="17" fill="#f2edff" color="#7C00FF" />
                            </Tooltip>

                          </div>
                        )}
                    </Form.Check>
                  </CardCustom>
                </Col>
              ))
            }
          </Row>
        )}

      {
        type === 'buttonSelector'
        && (
          <Row className="justify-content-center my-5 mb-5">
            {
              options.slice(0, collapsed ? options.length : max).map((option, i) => (
                <div
                  key={option.value}
                  className={`btn btn-secondary btn-check btn-rounded p-0 mr-3 mt-3 
                  ${isChecked(option) ? 'active' : ''} ${collapsed ? 'w-px-200' : ''}`}
                >
                  <Form.Check
                    className="w-100 h-100 form-check-button"
                    inline
                    type="radio"
                    id={`bot-check-${i}-id`}
                  >
                    <Form.Check.Input type="radio" hidden checked={isChecked(option)} value={option.value}
                      onChange={(e) => { handleChange(e.target.value); }}
                    />
                    <Form.Check.Label className="px-3 py-3">{parse(option.text || option.label)}</Form.Check.Label>
                  </Form.Check>
                </div>
              ))
            }
            {options.length > max
              && (
                <div className="mr-3 mt-3 d-inline btn btn-link" onClick={handleListMore} onKeyDown={handleListMore} role="button" tabIndex={0}>
                  <h6 className="mb-0">
                    {collapsed
                      ? (
                        <>
                          <span>Recolher</span>
                          <ChevronUp className="d-inline ml-2" size="18" />
                        </>

                      )
                      : (
                        <>
                          <span>Mais segmentos</span>
                          <ChevronDown className="d-inline ml-2" size="18" />
                        </>
                      )}
                  </h6>

                </div>
              )}
          </Row>
        )
      }

      <ButtonInput buttons={[{
        text: 'Continuar',
        disabled: type === 'radio' || type === 'buttonSelector' ? value === '' : value.size === 0,
        onClick: () => {
          let data;
          if (type === 'radio' || type === 'buttonSelector') {
            data = options.filter((o) => o.value === value);
            next(data[0]);
          } else {
            const valueList = Array.from(value);
            data = options.filter((o) => valueList.includes(o.value));
            next(data);
          }
        },
      }]}
      />
    </Container>
  );
};

export default RadioInput;
